module.exports = __webpack_public_path__ + "static/item-section-2-2686e7a250e4e2b7291ec244f8dea1f1.png";